import { render } from "./ModalResultPostTest.vue?vue&type=template&id=a5b0486c"
import script from "./ModalResultPostTest.vue?vue&type=script&lang=js"
export * from "./ModalResultPostTest.vue?vue&type=script&lang=js"
script.render = render

export default script